module.exports = __webpack_public_path__ + "assets/img/email_1.297c13a5.svg";